//components
import { MirandaGradientButton } from 'components/Button';

//styles
import {
  HeroWrapper,
  ContainerStyled,
  ChildrenWrapper,
  Logo,
  Title,
  Subtitle,
} from './Hero.styles';

export default function Hero({
  children,
  content = { subtitle: null, logo: null, image: null, gradient: null },
  gradient,
}) {
  return (
    <HeroWrapper>
      <ContainerStyled>
        {content.logo && <Logo>{content.logo}</Logo>}
        <Title>{content.title}</Title>
        {content.subtitle && <Subtitle as="p">{content.subtitle}</Subtitle>}
        <MirandaGradientButton
          as="a"
          href={content.button.url}
          className="noborder"
        >
          {content.button.text}
        </MirandaGradientButton>
      </ContainerStyled>
      {children && (
        <ChildrenWrapper gradient={gradient}>{children}</ChildrenWrapper>
      )}
    </HeroWrapper>
  );
}

export { Hero };
